import { createAudioPlayer } from '@mono-widgets/audio-players';

export const app = createAudioPlayer();
